import { render, staticRenderFns } from "./ResumenAcademico.vue?vue&type=template&id=4441e7aa&"
import script from "./ResumenAcademico.vue?vue&type=script&lang=js&"
export * from "./ResumenAcademico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports